export const INVITE_LABEL = 'Invite to Portal';

export const INVITED_LABEL = 'Invitation sent';

export const CONFIG_SELECT_LABEL = 'Advisor Portal';

export const CONFIG_SELECT_PLACEHOLDER = 'Select a portal';
